export default __webpack_public_path__ + "static/FbTestimonial2-68c61b70f65bf0c495bd5038ef9179ae.jpeg";